import React, { Component } from "react"
import PropTypes from "prop-types"
import { Carousel } from "react-responsive-carousel"

export default class CarListElement extends Component {
  _generateCarouselItems = () => {
    return this.props.car.images.map((image, i) => {
      const altText = `${this.props.car.headline || ''} - (${i + 1}/${this.props.car.images.length})`;
      return (
        <div key={i}>
          <img src={image} alt={altText} />
        </div>
      );
    });
  }

  _onClick = (e) => {
    const selected = this.props.selectedCar === this.props.car.id
    if (
      !e.target.classList.contains("control-arrow") &&
      !e.target.classList.contains("button-continue")
    ) {
      this.props.onClick(selected ? "" : this.props.car.id)
    }
  }

  render() {
    const {
      car: {
        id,
        headline,
        year,
        mileage,
        engine_size,
        fuel_type,
        location_city,
        location_region,
        price,
        images,
        emission_information,
      },
      selectedCar,
      strings,
    } = this.props

    // TODO: move to state
    const selected = selectedCar === id

    return (
      <div
        className={`car-list-element ${selected ? "selected" : ""}`}
        onClick={(e) => this._onClick(e)}
      >
        {/* container used purely as anchoring points to the Continue and Select controls */}
        <div className="container-car-image">
          <span className="select-control">
            <p>{selected ? strings.selectedCar : strings.selectCar}</p>
            <i className="select-control-checkbox" />
          </span>

          <span className="container-continue">
            {selected && !this.props.fromBookTestDrive ? (
              <button
                className="button-continue main-cta"
                onClick={() => this.props.submitAction()}
              >
                {strings.nextStepButtonText} ›
              </button>
            ) : null}
          </span>

          {images.length ? (
            <Carousel
              showIndicators={false}
              showThumbs={false}
              statusFormatter={(current, total) => `${current} / ${total}`}
            >
              {this._generateCarouselItems()}
            </Carousel>
          ) : (
            <div className="empty-image" />
          )}
        </div>

        <div className="container-car-info">
          {/* <img src={images[0]} style={{ maxWidth: '150px' }} /> */}
          <div className="headline-wrapper">
            <span className="headline">{headline}</span>
          </div>
          <span className="info-middle-left">
            <span>{year}</span>
            <span className="vertical-separator">|</span>
            <span>{mileage}</span>
          </span>
          <span className="info-middle-right">
            <span>{engine_size}</span> <span>{fuel_type}</span>
          </span>
          {emission_information ? (
            <div className="info-emissions">
              <span
                dangerouslySetInnerHTML={{ __html: emission_information }}
              />
            </div>
          ) : null}
          <span className="info-bottom-left">
            <span>{location_city}, </span>
            <span>{location_region}</span>
          </span>
          <span className="info-bottom-right price">
            <span>{price}</span>
          </span>
        </div>
      </div>
    )
  }
}

CarListElement.propTypes = {
  car: PropTypes.object,
  onClick: PropTypes.func,
  selectedCar: PropTypes.number,
  strings: PropTypes.object,
  submitAction: PropTypes.func,
  fromBookTestDrive: PropTypes.bool,
}
